export enum ActivationTypes {
    'by-courier' = 5,
    'by-mail' = 6,
    'esim' = 1,
}
